export default "__VITE_ASSET__CaZYHUja__";